/* eslint-disable lingui/no-unlocalized-strings -- cabeçalho e nomes do contrato da CreditAPI, não texto de UI */

/** Cabeçalho da autorização de uso único (`RequireStepUpAttribute.HeaderName` da CreditAPI). */
export const STEP_UP_HEADER = 'X-UY3-StepUp';

/**
 * Espelho do enum `StepUpAction` da CreditAPI (`Services/StepUp/StepUpAction.cs`); o nome vai assim no
 * `POST /Auth/StepUp/Start` e fica gravado na autorização: a de uma ação não serve para outra.
 */
export type StepUpAction =
  | 'TenantEnvironmentSubmit'
  | 'TenantEnvironmentApprove'
  | 'TenantEnvironmentRetry'
  | 'TenantEnvironmentCancel'
  | 'TenantRequestWrite'
  | 'UserCreate'
  | 'UserUpdate'
  | 'UserDelete'
  | 'UserCredentialReset'
  | 'GroupWrite'
  | 'GroupMembership'
  | 'PermissionWrite'
  | 'TenantPermissionResourceWrite'
  | 'SystemApplicationWrite'
  | 'TenantEnvironmentVisualUpdate'
  | 'ApiCredentialCreate'
  | 'ApiCredentialRevoke';

/**
 * A autorização devolvida pelo `POST /Auth/StepUp/Verify`. O token não é campo do objeto: só o cliente
 * HTTP o lê, uma vez, para pôr no cabeçalho. `JSON.stringify` e template string mostram `[step-up]`.
 */
export interface StepUpGrant {
  readonly action: string;
  readonly resourceId: string | null;
  readonly expiresAt: string;
}

const tokens = new WeakMap<StepUpGrant, string>();

// Classe, não objeto literal: o axios copia objeto simples da config (`mergeConfig`) e a cópia perderia o vínculo
// com o token e o `toJSON`.
class Grant implements StepUpGrant {
  readonly action: string;
  readonly resourceId: string | null;
  readonly expiresAt: string;

  constructor(meta: StepUpGrant) {
    this.action = meta.action;
    this.resourceId = meta.resourceId;
    this.expiresAt = meta.expiresAt;
    Object.freeze(this);
  }

  toJSON() {
    return '[step-up]';
  }

  toString() {
    return '[step-up]';
  }
}

/** Embrulha o `stepUpToken` do Verify; o token fica fora do objeto (log, telemetria, devtools do Query). */
export function createStepUpGrant(token: string, meta: StepUpGrant): StepUpGrant {
  const grant = new Grant(meta);
  tokens.set(grant, token);
  return grant;
}

/**
 * Tira o token da autorização para o cabeçalho: uso único também no cliente (a CreditAPI consome a autorização
 * mesmo quando a ação falha). Uma segunda chamada com a mesma autorização sai sem cabeçalho e recebe 403.
 */
export function takeStepUpToken(grant: StepUpGrant): string | undefined {
  const token = tokens.get(grant);
  tokens.delete(grant);
  return token;
}
